import React from 'react';
import styled from 'styled-components';
import ControlBlock from '../../UsersSubnavigation/ControlBlock';
import Videos from '../../Videos/VideosList/Videos';

const MotivationVideos = () => {
  return (
    <MotivationScreenContainer>
      <ControlBlock title="Видео тренировок" />
      <Videos />
    </MotivationScreenContainer>
  );
};

export default MotivationVideos;

const MotivationScreenContainer = styled.div`
  width: 70%;
  margin: 0 auto 10px auto;
  @media (max-width: 992px) {
    width: 80%;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Motivation/MotivationList/MotivationVideos.jsx